<template>
    <div>
        <div v-if="list.length != 0">
            <div class="item" v-for="item in list" :key="item.id">
                <div>
                    <div>购物卡卡号：{{item.series_number}}</div>
                    <div>交易单号：{{item.oid}}</div>
                    <div>抵扣金额：￥{{item.deduction}}</div>
                </div>
                <div class="date">交易时间：{{item.record_time}}</div>
            </div>
        </div>
        <div v-else style="margin: 200px auto; text-align:center">暂无抵扣记录</div>
    </div>
</template>
<script>
import { getCardMsg } from "@api/user";
export default {
    data(){
        return{
            number:'',
            list:[]
        }
    },
    mounted(){
        this.number = this.$route.params.num;
        this.getCardMsg();
    },
    methods:{
        getCardMsg(){
            this.$dialog.loading.open("加载中");
            getCardMsg({
                "condition_key" : "series_number",
                "condition_value" : this.number}).then(res=>{
            }).catch((err) => {
                if(err.data.code == 0){
                    this.list = err.data.data
                }else{
                    this.$dialog.error("获取数据失败");
                }
                this.$dialog.loading.close();
            });
        }
    },
    watch:{
        list(newVal,oldVal){
            newVal.forEach((val,key) => {
                var timelist = new Date(parseInt(val.record_time) * 1000)
                var year = timelist.getFullYear();
                var month =timelist.getMonth() + 1;
                var day = timelist.getDate();
                var times = year + "-" + month + "-" +day;
                this.list[key].record_time = times;
            });
        }
    }
}
</script>
<style scope>
.item{
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    margin: 10px;
    background-color: #b2d4f1;
    line-height: 1.8;
}
.date{
    text-align: end;
}
</style>